import { Chip, ListItemText, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import Pagination from "@mui/material/Pagination";
import React, { useState } from "react";
import MenuApp from "./MenuApp";

const ITEMS_PER_PAGE = 10; // Nombre d'éléments par page

const Liste = (props: any) => {
  const { filteredListe,updateFilteredListe } = props;
  const [page, setPage] = useState(1); // État pour suivre la page actuelle

  // Calculer les éléments affichés pour la page actuelle
  const startIndex = (page - 1) * ITEMS_PER_PAGE;
  const currentItems = filteredListe.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  // Gestion du changement de page
  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  return (
    <>
      <div
        style={{
          padding: 10,
          height: "40vh",
          overflow: "auto",
          marginTop: 10
        }}
      >
        <Box sx={{ flexGrow: 1, width: "100%" }}>
          <List dense={true}>
            {currentItems.map((item: any, i: number) => {
              return (
                <div key={i}>
                  <ListItem
                    secondaryAction={
                      <MenuApp 
                      item={item}
                      updateFilteredListe={updateFilteredListe}
                       />
                    }
                  >
                    <ListItem>
                      <ListItemButton>
                        <ListItemText
                          primary={`${item.codeEtab}`}
                          secondary={
                            <Box style={{ display: "flex", flexDirection: "column" }}>
                              <Typography variant="caption">
                                {`${item.anneeScolaire}`}
                              </Typography>
                              <Typography variant="caption">
                                Possibilité de souscrire en établissement: {item.souscrit === 1
                                  ? <Chip label="Oui" color="success" variant="outlined" size="small" />
                                  : <Chip label="Non" color="error" variant="outlined" size="small" />
                                }
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                  </ListItem>
                  <Divider />
                </div>
              );
            })}
          </List>
        </Box>
      </div>

      {/* Pagination */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Pagination
          count={Math.ceil(filteredListe.length / ITEMS_PER_PAGE)}
          page={page}
          onChange={handlePageChange}
          color="primary"
        />
      </Box>
    </>
  );
};

export default Liste;
